"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { readPendingPayment } from "@/lib/payment-pending";

const RETURN_PATH = "/payment/return";

/**
 * After a CIB payment the SATIM gateway returns the customer to a URL configured
 * server-side — which may land them anywhere in the app rather than on the
 * payment-result page. This guard funnels any in-flight payment to
 * {@link RETURN_PATH} so the result is always verified and shown, no matter
 * where the gateway dropped them. It is a no-op when there is no pending payment.
 */
export function PendingPaymentGuard() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (pathname === RETURN_PATH) return;
    if (!readPendingPayment()) return;
    router.replace(RETURN_PATH);
  }, [pathname, router]);

  return null;
}
